import React from "react";
import { Modal } from "antd";

const modalStyles = {
  content: {
    display: "flex",
    flexDirection: "column",
    height: "90vh",
    padding: 0,
  },
  header: {
    margin: 0,
    padding: "14px 20px",
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
};

const readerStyle = {
  border: 0,
  display: "block",
  height: "100%",
  width: "100%",
};

function PdfReaderModal({ open, onCancel, pdfUrl, title = "Lecteur PDF" }) {
  return (
    <Modal
      centered
      footer={null}
      open={open}
      onCancel={onCancel}
      styles={modalStyles}
      title={title}
      width="80vw"
    >
      {pdfUrl && <iframe src={pdfUrl} style={readerStyle} title={title} />}
    </Modal>
  );
}

export default PdfReaderModal;
